import {useContext, useEffect, useRef, useState} from "react";
import {Context} from "./Context";
import axios from "axios";

export const ChatSection = () => {
    const {questions,chattingData, setChattingData,startVal} = useContext(Context)
    const [userInput, setUserInput] = useState("");
    const scrollRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
    

    const handleScroll = (e, index) => {
        const {scrollTop} = e.target; // 현재 스크롤 위치 가져오기
        scrollRefs.forEach((ref, i) => {
            if (i !== index && ref.current) {
                ref.current.scrollTop = scrollTop; // 다른 ul도 동일한 위치로 스크롤
            }
        });
    };
  
    
    const handleAskQuestion = async (text) => {
        const step1OptionToText =questions[1].map(ques => `${ques["problem"].replace(",","")} : ${ques["selectVal"].join("")}\n`)
        const step2OptionToText =questions[2].map(ques => `${ques["problem"].replace(",","")} : ${ques["selectVal"].join("")}\n`)
        const optionText = step1OptionToText+step2OptionToText
        
        if (!text.trim()) return;
        if(chattingData.length === questions[0].length){
            alert("더 이상 질문 할 수 없습니다")
            return;
        }
        
        const newChatId = questions[0][chattingData.length]["id"];
        const newChat = {
            id: newChatId,
            userText: text,
            aiChat: null,
            selectedAi: "",
            userEditText :""
        };
        setChattingData(prev => [...prev, newChat]);
        setUserInput("");
        
        try {
            const response = await axios.post(`https://api.aiteditor.org/chatGpt/prompt`,{
                "model":"gpt-4o-mini",
                "messages": [
                    {
                        "role":"user",
                        "content": `${optionText}`
                    }
                ]
            })
            
            const result = response.data;
            const gptAnswer = result.choices?.[0]?.message?.content ?? "GPT 응답 없음";
            
            const fakeAiChat = {
                gpt: `(GPT) ${gptAnswer}`,
            };

            setChattingData(prev =>
                    prev.map((item, i) =>
                        i ===  prev.length - 1 ? { ...newChat, aiChat : fakeAiChat } : item
                    )
            );
            
        } catch (err) {
            console.error("질문 실패:", err);
        }
    };

    useEffect(()=>{
        if(startVal&&questions.length > 3 && chattingData.length ===0 ){
            handleAskQuestion('') //3단계에서 입력한 내용 추가
        }
    },[startVal])

    const handleRadioClick = (chatId, model) => {
        setChattingData(prev =>
            prev.map(chat =>
                ({...chat, selectedAi: model,userEditText:chat.aiChat[model] })
            )
        );
    }
    
    return (
        <section className={`w-full h-full flex flex-wrap gap-y-2 `}>
            {
                ["gpt"].map((model, index) => (
                    <div key={index}
                        ref={scrollRefs[index]} // useRef로 연결
                        onScroll={(e) => handleScroll(e, index)}
                        className="w-[100%]   overflow-y-scroll    border-b-2  h-[80vh] ">
                        {chattingData.map((chat) => (
                            <ul key={chat.id} className={`w-full   flex flex-col`}>
                                {/* 유저 메시지 */}
                                <li className="p-4 max-w-[70%] self-end text-black mb-5 rounded-3xl rounded-tr-none bg-slate-100 text-wrap whitespace-normal break-words">
                                    <span className="p-3">{chat.userText}</span>
                                </li>
                                {/* AI 모델 응답 */}
                                {
                                    chat.aiChat == null ? <h1 className={`text-center pb-5 font-bold`}>AI 답변 로딩..</h1> :
                                        <li className="p-4 max-w-[70%] self-start text-black mb-5 rounded-3xl rounded-tl-none bg-slate-300 text-wrap whitespace-normal break-words  relative">
                                            <span className="p-3">{chat.aiChat[model]}</span>
                                            <input type="radio"
                                                   className="absolute top-1/2 right-[-8%] transform -translate-y-1/2"
                                                   onClick={() => handleRadioClick(chat.id, model)}
                                                   checked={chat.selectedAi === model}
                                                   readOnly
                                            />
                                        </li>
                                }
                            </ul>
                        ))}
                    
                    </div>
                
                ))
            }
            <div className={`flex w-full`}>
                <div className={`w-full flex`}>
                    <input name="userChat" id="" className={`p-6 flex-grow`} placeholder={"질문"} onChange={(e)=>{setUserInput(e.target.value)}}></input>
                    <button onClick={()=>{handleAskQuestion(userInput)}} className={` bg-slate-800 text-white px-5 py-2`}>질문하기</button>
                </div>
            </div>
        </section>
    )
}